import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, DataTable, Card, Thumbnail, Button, Tabs } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
import FormPageActions from '@container/FormPageActions';
import SalesByTransfers from '@presentational/sale_report/SalesByTransfers';
import SalesBySeller from '@presentational/sale_report/SalesBySeller';

const propTypes = {
  saleReport: PropTypes.object.isRequired,
  pdfURL: PropTypes.string.isRequired,
  csvURL: PropTypes.string.isRequired,
  excelURL: PropTypes.string.isRequired,
  canGroupBySeller: PropTypes.bool,
};

const SaleReportShowLegacy = (props) => {
  const { saleReport } = props;
  const [selected, setSelected] = useState(0);

  const handleTabChange = useCallback((selectedTabIndex) => setSelected(selectedTabIndex), [],);

  let actions = [
    { content: 'Exportar PDF', url: props.pdfURL, external: true },
    { content: 'Exportar CSV', url: props.csvURL, external: true },
    { content: 'Exportar XLSX', url: props.excelURL, external: true },
  ];
  if(props.canGroupBySeller){
    actions = [ ...actions, 
      { content: "Exportar PDF agrupado por Seller", url: `${props.pdfURL}?by_seller=yes`, external: true },
      { content: "Exportar CSV agrupado por Seller", url: `${props.csvURL}?by_seller=yes`, external: true },
      { content: "Exportar XLSX agrupado por Seller", url: `${props.excelURL}?by_seller=yes`, external: true },
    ];
  }

  let tabs = [{ id: 'by-transfers', content: 'Agrupados por Entrega APU', accessibilityLabel: 'Entrega APU', panelID: 'by-transfers' }];
  if(props.canGroupBySeller)
    tabs = [...tabs, { id: "by-seller", content: "Agrupados por Seller", accessibilityLabel: "Seller", panelID: "by-seller" }]

  return(
    <AppProvider i18n={translations}>
      <Page
        fullWidth
        title={`${I18n.t("activerecord.models.sale_report.one")} ${saleReport.display_id}`}
        titleMetadata={ saleReport.date_range }
        breadcrumbs={[{content: I18n.t("actions.back"), url: '/sale_reports'}]}
        actionGroups={[
          {
            title: 'Exportar',
            accessibilityLabel: 'Action group label',
            actions: actions,
          },
        ]}
      >
        <Card title="Reporte Legacy">
          <div className={ tabs.length > 1 ? "meh" : "polaris-hide-tabs" }>
            <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
              { tabs[selected].id == "by-transfers" && <SalesByTransfers groupedItems={ saleReport.grouped_items.by_transfer } /> }
              { tabs[selected].id == "by-seller" && <SalesBySeller groupedItems={ saleReport.grouped_items.by_seller } /> }
  
              { saleReport.total_amounts.map( (data) =>
                <div className="row mb20" key={data.currency_symbol}>
                  <div className="col-md-2 offset-md-8 bg-black">
                    <div className="flex justifyEnd white pv15 container-fluid">
                      <strong>TOTAL</strong>: 
                    </div>
                  </div>
  
                  <div className="col-md-2 bg-black">
                    <div className="white pv15 container-fluid">
                      <strong>{ data.formatted_amount }</strong>
                    </div>
                  </div>
                </div>
              )}
            </Tabs>
          </div>
        </Card>
      </Page>
    </AppProvider>
  )
}


SaleReportShowLegacy.propTypes = propTypes;


export default SaleReportShowLegacy;
